import {MI} from "../init";
import {SymbolsManager} from "../symbol/SymbolsManager";
import {PreinfoMultiplier} from "./PreinfoMultiplier";
import {PreinfoFreespins} from "./PreinfoFreespins";
import {systemConfig} from "../../framework/src/engine/madnes/madnes_variables";
import {CONFIG_PARAMS} from "../../framework/src/system/SystemConfig";

/**
 * @constructor
 * @returns {Preinfo}
 */
export function Preinfo() {

	this.opened = true;

	/** @type {SymbolsManager} */
	this._symbolsManager;

	/** @type {MadnesGroup} */
	this._symbolsGroup;

	this._symbScale = 0.5;

	this._autorunFuncs = [];
	this._autorunIdx = 0;
	/** @type {MadnesTimer} */
	this._autorunInterval;
	/** @type {MadnesTimer} */
	this._autorunDelay;

	/** @type {MadnesObject} */
	this._bgCover;

	this._timeouts = [];

	/** @type {MadnesGroup} */
	this._controlsGroup;

	/** @type {Array<MadnesObject>} */
	this._stickSymbols;

	/** @type {MadnesObject} */
	this._featuredObj;
};

Preinfo.prototype.create = function() {

	var _self = this;

	// MI.controls.hideAllBtns();

	this._symbolsManager = new SymbolsManager();

	this._bgReels = MI.addImg(30, 230, "preinfo_atlas").setFrameName("background_reels");
	this._symbolsGroup = MI.addGroup("group_preinfo_symbols");

	this._multi = new PreinfoMultiplier();
	this._multi.create(this._symbolsManager, this._symbolsGroup);
	this._multi.setOnBtnClick(function() {
		_self._stopAutorun();
		_self._multi.run();
	});

	//this._multi.run();

	this._fs = new PreinfoFreespins();
	this._fs.create(this._symbolsManager, this._symbolsGroup);
	this._fs.setOnBtnClick(function() {
		_self._stopAutorun();
		_self._fs.run();
	});

	//this._fs.run();

	this._fs.createFires();

	this._bgCover = MI.addImg(0, 0, "preinfo_atlas").setFrameName("background_cover");

	this._fs.createRopes();
	this._fs.createFSLabel();

	this._controlsGroup = MI.addGroup("preinfo_controls");
	this._controlsGroup.add(this._fs.getBtn());
	this._controlsGroup.add(this._fs.getBtnShine());

	this._controlsGroup.add(this._multi.getBtn());
	this._controlsGroup.add(this._multi.getBtnShine());

	if (systemConfig.get(CONFIG_PARAMS.LANGUAGE) === "es") {
		this._featuredObj = MI.addImg(948, 132, "preinfo_atlas").setFrameName("featured_es");
	} else {
		this._featuredObj = MI.addImg(948, 132, "preinfo_atlas").setFrameName("featured");
	}
	this._featuredObj.setAnchor(0.5, 0.5);
	this._controlsGroup.add(this._featuredObj);

	this._timeouts[0] = 4000; // 3705.2109375ms
	this._timeouts[1] = 16600; // 16116.613037109375ms

	this._autorunFuncs[0] = function() { _self._multi.run(); };
	this._autorunFuncs[1] = function() { _self._fs.run(); };

	this._autorunDelay = MI.createTimer().add(function() {
//		_self._fs.run();
		_self._autorun();
	}, 1000);
};

Preinfo.prototype._autorun = function() {
	this._autorunInterval = MI.createTimer().add(this._autorun.bind(this), this._timeouts[this._autorunIdx]);

	this._autorunFuncs[this._autorunIdx]();
	this._autorunIdx++;

	if(this._autorunIdx >= this._autorunFuncs.length) {
		this._autorunIdx = 0;
	}
};


Preinfo.prototype.close = function() {

    this.opened = false;

	this._stopAutorun();

	this._symbolsManager = null;

	this._multi.destroy();
	this._fs.destroy();

	this._bgReels.destroy();
	this._bgCover.destroy();
	this._controlsGroup.destroy();
	this._symbolsGroup.destroy();

	// MI.controls.showAllBtns();
};

Preinfo.prototype._stopAutorun = function() {
	this._autorunInterval && this._autorunInterval.stop();
	this._autorunDelay && this._autorunDelay.stop();

	this._timeouts.length = 0;
	this._autorunFuncs.length = 0;
};